import { connect } from 'react-redux';
import { getLocalStoreRating, rateRating } from '../actions/RatingActions';
import Rating from '../components/RatingComponent';
import shorthash from '../../../helpers/shorthash';

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const isLive = aovivoBar.MediaPlayer.isLive !== 'otherMedia';
    const music = isLive
        ? aovivoBar.NowPlaying.musicLive
        : aovivoBar.NowPlaying.music;
    const { artist, song, time } = music;
    const { rating, musicHash } = aovivoBar.Rating;
    const newHash = shorthash(`${song}-${artist}-${time}`);

    return {
        artist,
        song,
        metaType: music.metaType,
        isLive,
        currentMetaId: aovivoBar.MediaPlayer.currentStream.metaId,
        settingRating: aovivoBar.Rating.settingRating,
        rating: newHash === musicHash ? rating : null,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getLocalStoreRating: () => {
        dispatch(getLocalStoreRating());
    },
    onLiked: () => {
        dispatch(rateRating(10));
    },
    onDisliked: () => {
        dispatch(rateRating(1));
    },
});

const RatingContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Rating);

export default RatingContainer;
